import { createLayeredConstructionApi } from "features/shared/layered-construction-config/api/createLayeredConstructionApi";
import { LayeredConstructionTab } from "features/shared/layered-construction-config/components/LayeredConstructionTab";
import { buildVariant } from "features/shared/layered-construction-config/model/variants";

const ROOF_VARIANT = buildVariant({
  cacheRoot: "roofConfigTab",
  catalogSegment: "roof-type-db",
  catalogTypeNameKey: "roofTypeName",
  countLabelKey: "rooftops",
  groupSegment: "roof-user-defined-types",
  i18nKey: "rooftop",
  typeDbIdKey: "roofTypeDbId",
  typeDbOverrideKey: "roofTypeDb",
});

export const RoofTab = ({ projectId }: { projectId: string }) => (
  <LayeredConstructionTab
    api={createLayeredConstructionApi(ROOF_VARIANT)}
    projectId={projectId}
    variant={ROOF_VARIANT}
  />
);
